import { ArticleSavedList } from '@xolv-mybrightlink/articles';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import {
  ResourcesHeader,
  useAnalytics,
  METRICS_SAVED_ARTICLES_ACTIVITY_ACCESS,
  METRICS_SAVED_EVENTS_ACTIVITY_ACCESS,
} from '@xolv-mybrightlink/common';
import { useState } from 'react';
import { EventSavedList } from '@xolv-mybrightlink/events';

const categories = [
  {
    id: 0,
    name: <FormattedMessage id='home.label.articles' />,
  },
  {
    id: 1,
    name: <FormattedMessage id='home.label.events' />,
  },
];

export const CmsSavedPage = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const analytics = useAnalytics();

  const onCategoryClicked = (selectedCategoryId: number) => {
    if (selectedCategoryId === 0) {
      analytics.trackAction(METRICS_SAVED_ARTICLES_ACTIVITY_ACCESS);
    } else if (selectedCategoryId === 1) {
      analytics.trackAction(METRICS_SAVED_EVENTS_ACTIVITY_ACCESS);
    }
    setSelectedCategoryId(selectedCategoryId);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          height: '100%',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              pl: 7.5,
              pr: 7.5,
            }}
          >
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 500,
                color: '#3b4559',
                cursor: 'pointer',
                mb: 2,
              }}
            >
              <FormattedMessage id='sidebar.menu.saved' />
            </Typography>
            <Box
              sx={{
                width: '30%',
                marginLeft: '30%',
              }}
            >
              <ResourcesHeader
                categories={categories.map((articleCategory) => ({
                  id: articleCategory.id,
                  name: articleCategory.name,
                }))}
                selectedCategoryId={selectedCategoryId}
                onCategoryClicked={onCategoryClicked}
                isResizable={false}
              />
            </Box>
          </Box>
        </Box>
        {selectedCategoryId === 0 && <ArticleSavedList />}
        {selectedCategoryId === 1 && <EventSavedList />}
      </Box>
    </Box>
  );
};
